export const CustomToast = (props) => {
    return (
        <div className={`custom-error-toast ${props.type}`}>
                <img className="toast-icon" src={props.type === "error" ? "/images/red-check-icon.svg" : "/images/green-check-icon.svg"} alt={`${props.type} Icon`} />

            <div className="toast-content">
                <p className="toast-title">{props.title ?? "Something went wrong!"}</p>
            </div>

            <img src="/images/cancel-green.svg" className="cancel-toast" onClick={props.closeToast} />
        </div>
    );
};
